import { Component, OnDestroy, OnInit, inject, ChangeDetectionStrategy } from '@angular/core'
import { toSignal } from '@angular/core/rxjs-interop'
import { MessageService } from '../services/message.service'
import { LocalStorageService } from 'app/core/services/local-storage.service'
import { SoundService } from 'app/core/services/sound.service'
import { LayoutService } from 'app/core/services/layout.service'
import { LayoutHeaderEnum } from 'app/core/constants/layout-header.enum'
import {
    canViewBidderDetailsBS,
    transportDrawerOpenBS,
    isSaleyardAuctionBS
} from 'app/modules/public/services/auction-helper.service'
import { Subscription } from 'rxjs'
import { map } from 'rxjs/operators'

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HeaderComponent implements OnInit, OnDestroy {
    readonly messageService = inject(MessageService)
    readonly localStorageService = inject(LocalStorageService)
    readonly soundService = inject(SoundService)
    readonly layoutService = inject(LayoutService)

    private auctionId: number = 0
    private subscriptions: Subscription[] = []
    hasBidderAccount = false
    readonly isSaleyardAuction = toSignal(isSaleyardAuctionBS.pipe(map((value) => value === true)), {
        initialValue: false
    })
    readonly canViewBidderDetails = toSignal(canViewBidderDetailsBS, { initialValue: false })

    get isSoundDisabled() {
        return this.soundService.isSoundDisabled
    }

    ngOnInit() {
        this.subscriptions.push(
            this.localStorageService.getStorageChanges().subscribe(() => {
                this.soundService.checkAuctionSound(this.auctionId)
            }),
            this.layoutService.header$.subscribe((header) => {
                if (header[LayoutHeaderEnum.AuctionId] && parseInt(header[LayoutHeaderEnum.AuctionId]) > 0) {
                    this.auctionId = parseInt(header[LayoutHeaderEnum.AuctionId])
                    this.soundService.checkAuctionSound(this.auctionId)
                }
            })
        )
    }

    ngOnDestroy() {
        this.subscriptions.forEach((subscription) => subscription.unsubscribe())
    }

    changeSoundStatus() {
        this.soundService.toggleAuctionSound(this.auctionId)
    }

    openTransportDrawer() {
        if (!this.canViewBidderDetails()) {
            return
        }
        if (transportDrawerOpenBS.getValue() === true) {
            return
        }

        transportDrawerOpenBS.next(true)
    }
}
